import React from 'react';
import styled from 'styled-components/macro';
import autoBind from 'auto-bind';
import * as colors from 'components/common/colorConstants';
import { setAnchorElementsTarget } from '../../../util';

class InstructionsContainer extends React.Component {
  constructor() {
    super();
    autoBind(this);
    this.state = {
      showFullInstruction: false,
    };
  }

  convertStringToHtml(string) {
    let htmlString = `<div>${string}</div>`;

    return { __html: htmlString };
  }

  toggleInstructions() {
    this.setState((prevState) => ({
      showFullInstruction: !prevState.showFullInstruction,
    }));
  }

  render() {
    const { instructions } = this.props;
    if (!instructions) {
      return null;
    }

    return (
      <Wrapper>
        <TextSection showFullInstruction={this.state.showFullInstruction}>
          <InstructionsText
            id="instructions-text"
            dangerouslySetInnerHTML={setAnchorElementsTarget(this.convertStringToHtml(instructions))}
          />
          <Toggle onClick={() => this.toggleInstructions()}>
            {!this.state.showFullInstruction ? (
              <>
                <DownArrow />
                SEE MORE
              </>
            ) : (
              <>
                <UpArrow />
                SEE LESS
              </>
            )}
          </Toggle>
        </TextSection>
        <GrayBar />
      </Wrapper>
    );
  }
}

export default InstructionsContainer;

const Wrapper = styled.div`
  width: 100%;
  border-bottom: 1px solid ${colors.lightGray15};
  background-color: ${colors.baseBackground};
`;

const TextSection = styled.section`
  text-align: left;
  font-size: 12px;
  font-family: 'Lato', sans-serif;
  transition: height 0.3s ease-in-out;
  padding: 40px 32px 20px;
  position: relative;
  overflow-y: hidden;
  max-height: ${(props) => (props.showFullInstruction ? '700px' : '90px')};
  transition: 0.4s;

  ::after {
    content: '';
    width: 100%;
    height: 60px;
    position: absolute;
    bottom: 0px;
    left: 0;
    transition: 0.4s;
    opacity: ${(props) => (props.showFullInstruction ? '0' : '1')};
    background-image: linear-gradient(to bottom, rgba(255, 254, 254, 0), #ffffff);
  }
`;

const InstructionsText = styled.div`
  font-size: 12px;
  color: ${colors.black4};
  h1,
  h2,
  h3,
  h4,
  h5 {
    margin-top: 0;
  }
`;

const GrayBar = styled.div`
  width: 100%;
  height: 7px;
  background-color: ${colors.lightGray14};
`;

const Arrow = styled.div`
  display: inline-block;
  height: 10px;
  width: 10px;
  position: relative;
  margin-right: 2px;
  top: 5px;
  background-size: 7px !important;
`;

const DownArrow = styled(Arrow)`
  background: url('/images/new-designs/chevron-down.svg') no-repeat;
`;

const UpArrow = styled(Arrow)`
  background: url('/images/new-designs/chevron-up.svg') no-repeat;
`;

const Toggle = styled.button`
  border: 0px;
  position: absolute;
  top: 15px;
  right: 15px;
  background-color: ${colors.baseBackground};
  font-weight: 500;
  font-size: 9px;
  cursor: pointer;
  text-align: right;
  text-transform: uppercase;
  color: ${colors.darkGray1};
`;
